<template>
  <tile-basic
    class="is-info"
    :values="keyValues(deployment)"
    :title="title"
    img="pkg"
    imgSize="75px"
    headerImg="pkg">
    <template slot="keyValue">
      <p v-if="deployment.status === 'complete'" class="vlevel-item">
        <span class="has-text-weight-semibold">Download: </span>
        <a @click="downloadPackage(deployment.id)">
          <svgicon name="download" height="30" width="30"></svgicon>
        </a>
      </p>
      <p v-else class="vlevel-item">
        <span class="has-text-weight-semibold">Status: </span>
        <span class="tag">{{ deployment.status.toUpperCase() }}</span>
      </p>
      <p v-if="deleteFunc" class="vlevel-item">
        <span class="has-text-weight-semibold">Delete: </span>
        <a @click="deleteFunc(deployment.id)">
          <svgicon name="delete" height="30" width="30" color="#CC6365"></svgicon>
        </a>
      </p>
    </template>
  </tile-basic>
</template>

<script>
import mixin from '@/mixins/deployments';
import TileBasic from '@/components/TileBasic.vue';

export default {
  name: 'TileDeployment',
  mixins: [mixin],
  components: {
    TileBasic,
  },
  props: {
    deployment: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: 'Deployment Info',
    },
    deleteFunc: {
      type: Function,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

.paddding {
  padding: 1rem;
}

</style>
